// --- NEW: formatting helper (display-only) ---
export const formatAmountWithCommas = (raw: string) => {
  // keep only one optional decimal part; if doesn't match, return as-is
  if (!/^\d+(\.\d{0,2})?$/.test(raw)) return raw;
  const [intPart, decPart] = raw.split('.');
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decPart !== undefined ? `${withCommas}.${decPart}` : withCommas;
};
